import { render, staticRenderFns } from "./CCollapse.vue?vue&type=template&id=570649a1&scoped=true"
import script from "./CCollapse.vue?vue&type=script&lang=ts&setup=true"
export * from "./CCollapse.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CCollapse.vue?vue&type=style&index=0&id=570649a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570649a1",
  null
  
)

export default component.exports